module.exports = __webpack_public_path__ + "./assets/img_kaostation_color@2x__1b8b47e6a2657ee0646303fa8d2b064c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_kaostation_color@2x.jpg
// module id = 615
// module chunks = 12